import React, { useEffect, useState } from "react";
import DateTimeRangeColorSelector from "components/dashboard/dataset-window/DateTimeRangeColorSelector";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { T } from "services/lang/LanguageService";
import { RadioButton } from "primereact/radiobutton";
import "./styles/style.scss";
import * as d3 from "d3";
import {ColorPicker, ColorPickerValueType} from "primereact/colorpicker";
import { Divider } from "primereact/divider";
import { IDataSet } from "./models/interfaces";
import { AggregationType, ChartType } from "./models/types";
import { getUniqueFlatArr } from "./utils/utils";

const SettingsDialog = ({
  displayDialog,
  selectedChartType,
  onHide,
  data,
  selectColorPalette,
  selectedColorPalette,
  selectAggregationMethod,
  setDatesRange,
  setSelectedColor,
  selectedColor
}: {
  displayDialog: boolean;
  selectedChartType: ChartType;
  onHide: any;
  data: IDataSet[];
  selectColorPalette: any;
  selectedColorPalette: { key: string; value: Array<any> };
  selectAggregationMethod: any;
  setDatesRange: (value: Date[]) => void
  setSelectedColor: (value: ColorPickerValueType) => void,
  selectedColor: ColorPickerValueType
}) => {
  const [selectedColors, setSelectedColors] = useState<{ key: string; value: Array<string> }>({ key: "", value: [] });
  const [aggregationMethodTemp, setAggregationMethodTemp] = useState<AggregationType>("SUM");
  const colorSchemesArr: Array<any> = [];
  let niceColorName = "";

  for (const [key, value] of Object.entries(d3)) {
    if (key.includes("scheme")) {
      niceColorName = key.replace("scheme", "");
      colorSchemesArr.push({ niceColorName, value });
    }
  }

  useEffect(() => {
    setSelectedColors(selectedColorPalette);
  }, [selectedColorPalette]);

  const handleSelectColorPalette = (e: { value: string }) => {
    const colorPaletteObj = colorSchemesArr.find((c) => c.niceColorName === e.value);
    colorPaletteObj.value = getUniqueFlatArr(colorPaletteObj.value);
    setSelectedColors(colorPaletteObj);
  };

  const handleEditColor = (e: any, i: number) => {
    e.preventDefault();
    if (selectedColors !== undefined) {
      const paletteCloneArr = JSON.parse(JSON.stringify(selectedColors?.value));
      paletteCloneArr[i] = `#${e.value}`;
      setSelectedColors({ ...selectedColors, value: paletteCloneArr });
    }
  };

  const TracesColors = () => {
    return (
      <div className="flexColumn mt-3">
        {data.map((d, i) => {
          let colorIndex: number;
          if (i < selectedColors.value.length) {
            colorIndex = i;
          } else {
            colorIndex = i - selectedColors.value.length;
          }
          const color = selectedColors?.value[colorIndex];
          return (
            <div className="colorContainer" key={d.identifier}>
              <h6>{d.title}</h6>
              <ColorPicker tooltip={color} format="hex" className="colorIcon" value={color} onChange={(e) => handleEditColor(e, colorIndex)} />
            </div>
          );
        })}
      </div>
    );
  };

  const AggregationMethod = () => {
    const aggreagtionMethodsArr: Array<{ key: string; method: AggregationType }> = [
      { key: "SUM", method: "SUM" },
      { key: "AVG", method: "AVG" },
      //  { key: "none", method: "none" },
    ];
    return (
      <div className="flexRow center">
        <Divider align="left" className="mr-3">
          <h6 className="mr-3">{T("label.aggregation-method-selection")}:</h6>
        </Divider>
        {aggreagtionMethodsArr.map((m, index) => {
          return (
            <div key={m.key} className="flexRow center mr-3">
              <RadioButton
                inputId={m.key}
                name="aggregation method"
                value={m.method}
                onChange={(e) => setAggregationMethodTemp(e.value)}
                checked={aggregationMethodTemp == m.key}
              />
              <label htmlFor={m.key}>{m.method}</label>
            </div>
          );
        })}
      </div>
    );
  };

  const handleConfirm = () => {
    selectColorPalette(selectedColors);
    selectAggregationMethod(aggregationMethodTemp);
    onHide();
  };

  const renderFooter = () => {
    return (
      <div className="flex flex-row flex-wrap ml-3 p-0 justify-content-end sm-flex-column">
        <Button label={T("word.no")} icon="pi pi-times" className="component-editor-button icon-red" onClick={onHide} />
        <Button label={T("word.yes")} icon="pi pi-check" className="component-editor-button icon-green" onClick={handleConfirm} />
      </div>
    );
  };

  return (
    <Dialog header={`${selectedChartType} ${T("word.settings")}`} visible={displayDialog} className="dialog" footer={renderFooter()} onHide={() => onHide(false)}>
      {selectedChartType === "PIE" && <AggregationMethod />}
      {selectedChartType === "SCATTER" && <DateTimeRangeColorSelector setDatesRange={setDatesRange} selectedColor={selectedColor} setSelectedColor={setSelectedColor} />}
      <div className="flex md:flex-row sm:flex-column center">
        <Divider align="left" className="mr-3">
          <h6>{T("label.color-palette-selection")}:</h6>
        </Divider>
        <Dropdown
          value={selectedColorPalette?.key}
          options={colorSchemesArr.map((c) => c.niceColorName)}
          onChange={handleSelectColorPalette}
          placeholder={T("action.select-color-palette")}
          className="h-3rem"
        />

      </div>
      <TracesColors />
    </Dialog>
  );
};

export default SettingsDialog;
